import { Row, Col } from "reactstrap";
import { Button, Modal } from "antd";
import { motion } from "framer-motion";
import { BulbTwoTone } from "@ant-design/icons";
import firstBusImg from "../../../assets/images/firstBusImg.png";
import "../utils/firstBusiness.css";

const FirstBusinessModal = ({ onClose }) => {
  return (
    <Modal
      open={true}
      width={600}
      footer={null}
      closable={false}
      centered
      className="first-business-modal"
    >
      <motion.div
        className="first-business-wrapper text-center"
        initial={{ opacity: 0, scale: 0.98 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <motion.div
          className="first-business-img mb-3"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <img src={firstBusImg} alt="business illustration" />
        </motion.div>

        <motion.h2
          className="first-business-title"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          Création de votre 1er business
        </motion.h2>

        <motion.p
          className="first-business-description"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.6 }}
        >
          Pour commencer à utiliser Paxity et accepter des paiements,
          nous avons besoin de quelques informations sur votre entreprise.
          Ce processus ne prendra que quelques minutes.
        </motion.p>

        <motion.div
          className="first-business-tip-box"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.6 }}
        >
          <BulbTwoTone twoToneColor="#2f54eb" />
          <span className="tip-text">
            <strong>Astuce :</strong> Vous pourrez ajouter plus d'informations
            (documents, responsables) plus tard pour débloquer toutes les
            fonctionnalités de la plateforme.
          </span>
        </motion.div>

        <motion.div
          className="first-business-action"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8, duration: 0.6 }}
        >
          <Button type="primary" size="large" onClick={onClose}>
            Créer un business
          </Button>
        </motion.div>
      </motion.div>
    </Modal>
  );
};

export default FirstBusinessModal;
